<template>
  <div class="loading">
    <div class="loading__inner">
      <img
        class="loading__gif"
        src="../../assets/img/official-account/0.gif"
        alt="loading"
      />
      <template v-if="rich">
        <div class="loading__status">正在提交工单，请稍候</div>
        <div class="loading__subtitle">提交过程请勿关闭页面</div>
        <div class="loading__tip">
          <svg
            class="loading__tip__icon"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="8" cy="8" r="7" stroke="#60bb46" stroke-width="1.2" />
            <rect x="7.3" y="6.5" width="1.4" height="5" rx="0.7" fill="#60bb46" />
            <circle cx="8" cy="4.6" r="0.9" fill="#60bb46" />
          </svg>
          <span
            >附件较大（&gt;20MB）可能导致提交耗时较长，请耐心等待</span
          >
        </div>
        <div class="loading__tip loading__tip--warn">
          <svg
            class="loading__tip__icon"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="8" cy="8" r="7" stroke="#d97706" stroke-width="1.2" />
            <rect x="7.3" y="4.5" width="1.4" height="5" rx="0.7" fill="#d97706" />
            <circle cx="8" cy="11.4" r="0.9" fill="#d97706" />
          </svg>
          <span>提交成功后请记得将工单编号截图或复制保存</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 是否显示提交工单的完整文案（标题/副标题/附件与保存提示）
    // 默认 false —— 仅显示 GIF，供列表/详情等通用加载场景使用
    rich: { type: Boolean, default: false },
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  &__inner {
    width: 100%;
    max-width: 320px;
    padding: 0 24px;
    text-align: center;
  }
  &__gif {
    width: 180px;
    height: 180px;
    display: block;
    margin: 0 auto;
  }
  &__status {
    margin-top: 4px;
    font-size: 16px;
    font-weight: 600;
    color: #60bb46;
    letter-spacing: 0.5px;
  }
  &__subtitle {
    margin-top: 6px;
    font-size: 12px;
    color: #999;
    letter-spacing: 0.3px;
  }
  &__tip {
    margin-top: 12px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 14px;
    background: #f0fae6;
    border-radius: 999px;
    font-size: 12px;
    color: #5a7a3e;
    line-height: 1.5;
    max-width: 100%;
    text-align: left;
    &:first-of-type {
      margin-top: 20px;
    }
    &__icon {
      flex-shrink: 0;
      width: 14px;
      height: 14px;
    }
    &--warn {
      background: #fff7ed;
      color: #d97706;
    }
  }
}
</style>
